module.exports = __webpack_public_path__ + "static/media/reactjs.8a48bf9b.png";